import React, { useState, useEffect, useRef, useCallback } from 'react';
import CardForEvent from '../../items/CardForEvent';
import ModalWithCard from '../../items/ModalWithCard.js';
import CompilerEventBody from './CompilerEventBody.js';
import { useProSidebar } from 'react-pro-sidebar';

const Feedback = ({ event, saveEvent, edit, delEvent, settings, getToken, config, userdata }) => {
  const { broken } = useProSidebar();
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      {userdata ? (
        <div class='w-full'>
          {/* Карточка для event-а*/}
          <CardForEvent settings={settings} setShowModal={setShowModal}>
            <CompilerEventBody
              event={event}
              getToken={getToken}
              userdata={userdata}></CompilerEventBody>
          </CardForEvent>
        </div>
      ) : (
        <CardForEvent settings={settings} setShowModal={setShowModal}>
          <p>
            Компилятор доступен только зарегистрированным пользователям. Пожалуйста
            зарегистрируйтесь или войдите под своей учетной записью
          </p>
        </CardForEvent>
      )}
    </>
  );
};

export default Feedback;
